import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

import { BackendService } from './backend.service';

import {
	AuthLoginRequest,
	AuthLoginResponse,
} from '../../shared/models/auth.model';
import { BaseResponse } from '../../shared/models/base-response.model';

const API_URL = environment.apiUrl;

export const AUTH_LOGIN_URL = `${API_URL}/web/auth/login`;
export const AUTH_LOGIN_RESPONSE = 'Logged In';

export const AUTH_LOGOUT_URL = `${API_URL}/web/auth/logout`;
export const AUTH_LOGOUT_RESPONSE = 'Logged Out';

@Injectable({
	providedIn: 'root',
})
export class AuthBackendService {
	constructor(private backendService: BackendService) {}

	/**
	 * User Login
	 * ===========
	 * API Endpoint: /web/auth/login
	 * JSON Parameters: netId, password
	 */
	login(request: AuthLoginRequest): Observable<AuthLoginResponse> {
		return this.backendService
			.post(AUTH_LOGIN_URL, AUTH_LOGIN_RESPONSE, request)
			.pipe(map((r: AuthLoginResponse) => r));
	}

	/**
	 * User Logout
	 * ============
	 * API Endpoint: /web/auth/logout
	 * No parameters
	 */
	logout(): Observable<BaseResponse> {
		return this.backendService.post(
			AUTH_LOGOUT_URL,
			AUTH_LOGOUT_RESPONSE,
			{}
		);
	}
}
